"use strict";

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  margin: 0 0 ", "px;\n  font-size: ", "px;\n  line-height: ", ";\n  font-weight: ", ";\n  color: #939ea9;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = require("../../../theme/styled");

var CardSubTitle = styled_1["default"]('h3')(_templateObject(), function (props) {
  return props.theme.space[2];
}, function (props) {
  return props.theme.fontSizes[0];
}, function (props) {
  return props.theme.lineHeights.body;
}, function (props) {
  return props.theme.fontWeights.body;
});
exports["default"] = CardSubTitle;